export default "__VITE_ASSET__MJ9G$9$r__"